import React, { useEffect, useState } from "react";

const emptyForm = {
  title: "",
  speaker: "",
  date: "",
  description: "",
  videoType: "upload",
  youtubeUrl: "",
  videoFile: null,
  thumbnailFile: null,
};

export default function VideoUploadForm({
  onAddVideo,
  isAdmin,
  editingVideo = null,
}) {
  const [formData, setFormData] = useState(emptyForm);

  useEffect(() => {
    if (editingVideo) {
      setFormData({
        title: editingVideo.title || "",
        speaker: editingVideo.speaker || "",
        date: editingVideo.date || "",
        description: editingVideo.description || "",
        videoType: editingVideo.videoType || "upload",
        youtubeUrl: editingVideo.youtubeUrl || "",
        videoFile: null,
        thumbnailFile: null,
      });
    } else {
      setFormData(emptyForm);
    }
  }, [editingVideo]);

  function handleChange(event) {
    const { name, value, files, type } = event.target;

    if (type === "file") {
      setFormData((prev) => ({
        ...prev,
        [name]: files && files[0] ? files[0] : null,
      }));
      return;
    }

    setFormData((prev) => {
      const updated = { ...prev, [name]: value };

      if (name === "videoType") {
        if (value === "upload") {
          updated.youtubeUrl = "";
        } else {
          updated.videoFile = null;
        }
      }

      return updated;
    });
  }

  async function handleSubmit(event) {
    event.preventDefault();

    const payload = new FormData();
    payload.append("title", formData.title);
    payload.append("speaker", formData.speaker);
    payload.append("date", formData.date);
    payload.append("description", formData.description);
    payload.append("videoType", formData.videoType);

    if (
      (formData.videoType === "youtube" ||
        formData.videoType === "youtube_live") &&
      formData.youtubeUrl
    ) {
      payload.append("youtubeUrl", formData.youtubeUrl);
    }

    if (formData.videoType === "upload" && formData.videoFile) {
      payload.append("videoFile", formData.videoFile);
    }

    if (formData.thumbnailFile) {
      payload.append("thumbnailFile", formData.thumbnailFile);
    }

    await onAddVideo(payload);

    if (!editingVideo) {
      setFormData(emptyForm);
      event.target.reset();
    }
  }

  if (!isAdmin) {
    return null;
  }

  const isUpload = formData.videoType === "upload";
  const isYoutube = formData.videoType === "youtube";
  const isYoutubeLive = formData.videoType === "youtube_live";
  const needsYoutubeUrl = isYoutube || isYoutubeLive;

  return (
    <div className="form-card">
      <h3>{editingVideo ? "Edit Guest Speaker Video" : "Add Guest Speaker Video"}</h3>

      <form className="form-grid" onSubmit={handleSubmit}>
        <div>
          <label className="label" htmlFor="vid-title">Video Title</label>
          <input
            className="input"
            id="vid-title"
            type="text"
            name="title"
            value={formData.title}
            onChange={handleChange}
            required
          />
        </div>

        <div>
          <label className="label" htmlFor="vid-speaker">Speaker Name</label>
          <input
            className="input"
            id="vid-speaker"
            type="text"
            name="speaker"
            value={formData.speaker}
            onChange={handleChange}
            required
          />
        </div>

        <div>
          <label className="label" htmlFor="vid-date">Date</label>
          <input
            className="input"
            id="vid-date"
            type="date"
            name="date"
            value={formData.date}
            onChange={handleChange}
            required
          />
        </div>

        <div>
          <label className="label" htmlFor="vid-type">Video Source Type</label>
          <select
            className="input"
            id="vid-type"
            name="videoType"
            value={formData.videoType}
            onChange={handleChange}
          >
            <option value="upload">Upload Video File</option>
            <option value="youtube">YouTube / Unlisted YouTube</option>
            <option value="youtube_live">YouTube Live Stream</option>
          </select>
        </div>

        {isUpload ? (
          <div>
            <label className="label" htmlFor="vid-file">
              {editingVideo ? "Replace Video File (optional)" : "Video File"}
            </label>
            <input
              className="input"
              id="vid-file"
              type="file"
              name="videoFile"
              accept="video/*"
              onChange={handleChange}
              required={!editingVideo}
            />
          </div>
        ) : (
          <div>
            <label className="label" htmlFor="vid-url">
              {isYoutubeLive ? "YouTube Live URL" : "YouTube URL"}
            </label>
            <input
              className="input"
              id="vid-url"
              type="url"
              name="youtubeUrl"
              value={formData.youtubeUrl}
              onChange={handleChange}
              placeholder="https://www.youtube.com/watch?v=..."
              required={needsYoutubeUrl}
            />
          </div>
        )}

        <div>
          <label className="label" htmlFor="vid-thumb">
            {editingVideo
              ? "Replace Thumbnail Image (optional)"
              : "Thumbnail Image (optional)"}
          </label>
          <input
            className="input"
            id="vid-thumb"
            type="file"
            name="thumbnailFile"
            accept="image/*"
            onChange={handleChange}
          />
        </div>

        <div>
          <label className="label" htmlFor="vid-desc">Description</label>
          <textarea
            className="textarea"
            id="vid-desc"
            name="description"
            value={formData.description}
            onChange={handleChange}
          />
        </div>

        <button className="btn btn-primary" type="submit">
          {editingVideo ? "Update Video" : "Save Video"}
        </button>
      </form>
    </div>
  );
}
